import { useEffect, useState } from "react";

import { collection, getDocs } from "firebase/firestore";
import { getRef } from "lib/firebase";
import { convertDate } from "lib/utils";

import { CurrentUser, IndexArticle } from "lib/type";

export const useDraft = (
  isAuthChecking: boolean,
  user: CurrentUser,
  author: CurrentUser
) => {
  const [drafts, setDrafts] = useState<IndexArticle[]>([]);
  useEffect(() => {
    if (isAuthChecking || !user || !author || user.uid !== author.uid) return;
    const getDraftArticles = async () => {
      const userDocRef = getRef("users", user.uid);
      const draftDocs = await getDocs(
        collection(userDocRef, "draftArticles")
      ).catch((err) => {
        console.log(err);
        alert("下書き記事の取得に失敗しました。");
        return null;
      });
      if (!draftDocs || draftDocs.empty) return;
      const draftArticles: IndexArticle[] = await Promise.all(
        draftDocs.docs.map(async (articleDoc) => {
          const article = articleDoc.data();
          const { thumb, title, color, createdAt } = article;
          const createDate = convertDate(createdAt);
          return {
            articleID: articleDoc.id,
            thumb: thumb,
            title: title,
            color: color,
            createdAt: createDate,
          };
        })
      );
      if (draftArticles.length < 1) return;
      setDrafts(draftArticles);
    };
    getDraftArticles();
  }, [author, isAuthChecking, user]);

  return { drafts };
};
